import call from './call';
import {SHOW_MSG} from "../types";
import languages from "../language/languages";

export default (form, onFinishCallBack) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            dispatch({
                type: SHOW_MSG,
                payload: {message: languages[getState().auth.language].processOk, type: 'success'}
            });
            if(onFinishCallBack)
                onFinishCallBack();
        }
    }
    dispatch(call("CertificateService/deleteCertificateRequest",form,onResult));
};